export default __webpack_public_path__ + "assets/67c4b8c18b7dd36886eb4c7fceacffbe.svg";